import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TFMService } from 'app/mock-api/tfm.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-unreservebookingmodal',
  standalone: true,
  imports: [],
  templateUrl: './unreservebookingmodal.component.html',
  styleUrl: './unreservebookingmodal.component.scss'
})
export class UnreservebookingmodalComponent {
  UnprebookCompleted$ = new Subject<boolean>();

  constructor(private tfmService :TFMService,public dialogRef: MatDialogRef<UnreservebookingmodalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any){
        console.log('Guid',data)

  }


    itinUnPreBook(itinGuid, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();
    this.close();
    this.tfmService.getItin(itinGuid).subscribe(res => {
      this.tfmService.filterAndSend(res.content.itinerary._links, "unprebook").subscribe(resUnPrebook => {
        console.log("Un-Reserved complete");
        this.tfmService.getItin(itinGuid);
         this.itinOptionsLoad();
          this.UnprebookCompleted$.next(true);
          this.UnprebookCompleted$.complete();
      });
    });
  }
  itinOptionsLoad(){
        var itinGuid = this.tfmService.getLocalItinGuid();

this.tfmService.getItinOptions(itinGuid).subscribe(resOptions => {

      var res = resOptions.content;

      res.forEach(option => {
        this.tfmService.getItinItems(option.itinerary.guid).subscribe(optionItems => {
          option.itinerary.items = optionItems;

          this.tfmService.filterAndSend(option.itinerary._links, "payments").subscribe(res => {
            option.itinerary.payments = res;
          });
        });

        // this.getPayments(option.itinerary);
        // console.log("getPayments");
      });
    });
  }
  close(): void {
    this.dialogRef.close(false);
  }
  

}
